import {
  faHome,
  faUsers,
  faGears,
  faIndianRupeeSign,
  faChartPie,
  faFileInvoice,
  faHeadphones,
} from '@fortawesome/free-solid-svg-icons';
import {
  MASTER_MODULES,
  MODULES,
  ROUTE_TYPES,
  PERMISSION_TYPES,
  VIEW_TYPES,
} from './index';
import Login from '../containers/Auth/Login';
import ForgotPassword from '../containers/Auth/ForgotPassword';
import Profile from '../containers/Auth/Profile';
import ChangePassword from '../containers/Auth/ChangePassword';
import Sessions from '../containers/Auth/Sessions';
import Logs from '../containers/Auth/Logs';
import Dashboard from '../containers/Dashboard/Dashboard';
// Accounts Management
import UsersList from '../containers/AccountsManagement/Users/UsersList';
import UsersCreate from '../containers/AccountsManagement/Users/UsersCreate';
import UsersUpdate from '../containers/AccountsManagement/Users/UsersUpdate';
import UsersWalletTransactionsList from '../containers/AccountsManagement/Users/UsersWalletTransactionsList';
import UsersFundSwitchingTransactionsList from '../containers/AccountsManagement/Users/UsersFundSwitchingTransactionsList';
import UsersFundTransfersList from '../containers/AccountsManagement/Users/UsersFundTransfersList';
import UsersKYCList from '../containers/AccountsManagement/Users/UsersKYCList';
import UsersBankAccountsList from '../containers/AccountsManagement/Users/UsersBankAccountsList';
import UsersFundRequestsList from '../containers/AccountsManagement/Users/UsersFundRequestsList';
import UsersWithdrawRequestsList from '../containers/AccountsManagement/Users/UsersWithdrawRequestsList';
import UsersWithdrawRequestsListNonGst from '../containers/AccountsManagement/Users/UsersWithdrawRequestsListNonGst';
import StaffAccountsList from '../containers/AccountsManagement/StaffAccounts/StaffAccountsList';
import StaffAccountsCreate from '../containers/AccountsManagement/StaffAccounts/StaffAccountsCreate';
import StaffAccountsUpdate from '../containers/AccountsManagement/StaffAccounts/StaffAccountsUpdate';
import RolesAndPermissionsList from '../containers/AccountsManagement/RolesAndPermissions/RolesAndPermissionsList';
import RolesAndPermissionsCreate from '../containers/AccountsManagement/RolesAndPermissions/RolesAndPermissionsCreate';
import RolesAndPermissionsUpdate from '../containers/AccountsManagement/RolesAndPermissions/RolesAndPermissionsUpdate';
// Configurations
import FirmDetails from '../containers/Configurations/FirmDetails/FirmDetails';
import AppConfiguration from '../containers/Configurations/AppConfiguration/AppConfiguration';
import BankAccountsList from '../containers/Configurations/BankAccounts/BankAccountsList';
import BankAccountsCreate from '../containers/Configurations/BankAccounts/BankAccountsCreate';
import BankAccountsUpdate from '../containers/Configurations/BankAccounts/BankAccountsUpdate';
import ScrollMessage from '../containers/Configurations/ScrollMessage/ScrollMessage';
import SmsAPIConfiguration from '../containers/Configurations/SmsAPIConfiguration/SmsAPIConfiguration';
import WhatsappAPIConfiguration from '../containers/Configurations/WhatsappAPIConfiguration/WhatsappAPIConfiguration';
import PaymentGatewayConfigurationTable from '../containers/Configurations/PaymentGatewayConfiguration/PaymentGatewayConfigurationTable';
import PaymentGatewayConfigurationCreate from '../containers/Configurations/PaymentGatewayConfiguration/PaymentGatewayConfigurationCreate';
import PaymentGatewayConfigurationUpdate from '../containers/Configurations/PaymentGatewayConfiguration/PaymentGatewayConfigurationUpdate';
import SendNotifications from '../containers/Configurations/SendNotifications/SendNotifications';
// Recharge Configurations
import CirclesList from '../containers/RechargeConfigurations/Circles/CirclesList';
import CirclesCreate from '../containers/RechargeConfigurations/Circles/CirclesCreate';
import CirclesUpdate from '../containers/RechargeConfigurations/Circles/CirclesUpdate';
import OperatorsList from '../containers/RechargeConfigurations/Operators/OperatorsList';
import OperatorsCreate from '../containers/RechargeConfigurations/Operators/OperatorsCreate';
import OperatorsUpdate from '../containers/RechargeConfigurations/Operators/OperatorsUpdate';
import CategoriesList from '../containers/RechargeConfigurations/Categories/CategoriesList';
import CategoriesCreate from '../containers/RechargeConfigurations/Categories/CategoriesCreate';
import CategoriesUpdate from '../containers/RechargeConfigurations/Categories/CategoriesUpdate';
import AdminOperatorMarginList from '../containers/RechargeConfigurations/AdminOperatorMargin/AdminOperatorMarginList';
import AdminOperatorMarginCreate from '../containers/RechargeConfigurations/AdminOperatorMargin/AdminOperatorMarginCreate';
import AdminOperatorMarginUpdate from '../containers/RechargeConfigurations/AdminOperatorMargin/AdminOperatorMarginUpdate';
import AdminUserOperatorMarginList from '../containers/RechargeConfigurations/AdminUserOperatorMargin/AdminUserOperatorMarginList';
import AdminUserOperatorMarginCreate from '../containers/RechargeConfigurations/AdminUserOperatorMargin/AdminUserOperatorMarginCreate';
import AdminUserOperatorMarginUpdate from '../containers/RechargeConfigurations/AdminUserOperatorMargin/AdminUserOperatorMarginUpdate';
import PlanAPIConfiguration from '../containers/RechargeConfigurations/PlanAPIConfiguration/PlanAPIConfiguration';
import APIProvidersList from '../containers/RechargeConfigurations/APIProviders/APIProvidersList';
import APIProvidersCreate from '../containers/RechargeConfigurations/APIProviders/APIProvidersCreate';
import APIProvidersUpdate from '../containers/RechargeConfigurations/APIProviders/APIProvidersUpdate';
import SellerAPISList from '../containers/RechargeConfigurations/SellerAPIS/SellerAPISList';
import SellerAPISCreate from '../containers/RechargeConfigurations/SellerAPIS/SellerAPISCreate';
import SellerAPISUpdate from '../containers/RechargeConfigurations/SellerAPIS/SellerAPISUpdate';
import OperatorBlockerList from '../containers/RechargeConfigurations/OperatorBlocker/OperatorBlockerList';
import OperatorBlockerCreate from '../containers/RechargeConfigurations/OperatorBlocker/OperatorBlockerCreate';
import BuyerMarginsList from '../containers/RechargeConfigurations/Margins/BuyerMarginsList';
import SellerMarginsList from '../containers/RechargeConfigurations/Margins/SellerMarginsList';
import AutoResolveComplaintsList from '../containers/RechargeConfigurations/AutoResolveComplaints/AutoResolveComplaintsList';
import AutoResolveComplaintsCreate from '../containers/RechargeConfigurations/AutoResolveComplaints/AutoResolveComplaintsCreate';
import AutoResolveComplaintsUpdate from '../containers/RechargeConfigurations/AutoResolveComplaints/AutoResolveComplaintsUpdate';
import LapuSlugsList from '../containers/RechargeConfigurations/LapuSlugs/LapuSlugsList';
import LapuSlugsCreate from '../containers/RechargeConfigurations/LapuSlugs/LapuSlugsCreate';
import LapuSlugsUpdate from '../containers/RechargeConfigurations/LapuSlugs/LapuSlugsUpdate';
// Transactions
import IssueRechargeTransactionsList from "../containers/Transactions/IssueRechargeTransactionsList";
import BuyerRechargeTransactionsList from '../containers/Transactions/BuyerRechargeTransactionsList';
import SellerRechargeTransactionsList from '../containers/Transactions/SellerRechargeTransactionsList';
import PendingRechargeTransactionsList from '../containers/Transactions/PendingRechargeTransactionsList';
import DisputedRechargeTransactionsList from '../containers/Transactions/DisputedRechargeTransactionsList';
import LiveRechargeTransactionsList from '../containers/Transactions/LiveRechargeTransactionsList';
// Reports
import BuyersOperatorDayBook from '../containers/Reports/BuyersOperatorDayBook';
import SellersOperatorDayBook from '../containers/Reports/SellersOperatorDayBook';
import Daybook from '../containers/Reports/Daybook';
import Downloads from '../containers/Reports/Downloads';
// Invoicing
import BuyerInvoices from '../containers/Invoicing/BuyerInvoices';
import SellerInvoices from '../containers/Invoicing/SellerInvoices';
import PaymentGatewayDepositsTable from '../containers/Invoicing/PaymentGatewayDepositsTable';
// Support
import SupportTickets from "../containers/Support/SupportTickets";
import SellerAPISSupportTickets from "../containers/Support/SellerAPISSupportTickets";

const { ALLOW_IF_LOGGEDIN, ALLOW_IF_NOT_LOGGEDIN } = ROUTE_TYPES;
const {
  ACCOUNTS_MANAGEMENT,
  CONFIGURATIONS,
  RECHARGE_CONFIGURATIONS,
  TRANSACTIONS,
  REPORTS,
  INVOICING,
  SUPPORT,
} = MASTER_MODULES;
const {
  // Accounts Management - ACCOUNTS_MANAGEMENT
  USERS,
  USERS_KYC,
  USERS_BANK_ACCOUNTS,
  USERS_FUND_REQUESTS,
  USERS_WITHDRAW_REQUESTS,
  USERS_FUND_TRANSFERS,
  STAFF_ACCOUNTS,
  ROLES_AND_PERMISSIONS,
  // Configurations - CONFIGURATIONS
  FIRM_DETAILS,
  APP_CONFIGURATION,
  BANK_ACCOUNTS,
  SCROLL_MESSAGE,
  SMS_API,
  WHATSAPP_API,
  PAYMENT_GATEWAY_CONFIGURATION,
  SEND_NOTIFICATIONS,
  // Recharge Configurations - RECHARGE_CONFIGURATIONS
  CIRCLES,
  OPERATORS,
  CATEGORIES,
  ADMIN_OPERATOR_MARGINS,
  ADMIN_USER_OPERATOR_MARGINS,
  PLAN_API_CONFIGURATION,
  API_PROVIDERS,
  SELLER_APIS,
  OPERATORS_BLOCKER,
  BUYER_MARGINS,
  SELLER_MARGINS,
  AUTO_RESOLVE_COMPLAINTS,
  LAPU_SLUGS,
  // Transactions - TRANSACTIONS
  BUYER_RECHARGE_TRANSACTIONS,
  SELLER_RECHARGE_TRANSACTIONS,
  PENDING_RECHARGE_TRANSACTIONS,
  DISPUTED_RECHARGE_TRANSACTIONS,
  LIVE_RECHARGE_TRANSACTIONS,
  ISSUE_RECHARGE_TRANSACTIONS,
  // Reports - REPORTS
  BUYERS_OPERATORS_DAY_BOOK,
  SELLERS_OPERATORS_DAY_BOOK,
  DAY_BOOK,
  DOWNLOADS,
  // Invoicing - INVOICING
  BUYER_INVOICES,
  SELLER_INVOICES,
  PAYMENT_GATEWAY_DEPOSITS,
  // Support - SUPPORT
  SUPPORT_TICKETS,
  SELLER_APIS_SUPPORT_TICKETS,
} = MODULES;
const {
  CREATE,
  READ,
  UPDATE,
  WALLET_TRANSACTIONS,
  FUND_SWITCHING_TRANSACTIONS,
} = PERMISSION_TYPES;
const { TABLE, GRID } = VIEW_TYPES;

const ROUTES = [
  {
    path: '/',
    title: 'Dashboard',
    icon: faHome,
    routeType: ALLOW_IF_LOGGEDIN,
    component: Dashboard,
    hideHeading: true,
    hideBreadcrumbs: true,
    exact: true,
  },
  {
    path: '/login',
    title: 'Login',
    routeType: ALLOW_IF_NOT_LOGGEDIN,
    component: Login,
    hideInNavigation: true,
  },
  {
    path: '/forgot-password',
    title: 'Forgot Password',
    routeType: ALLOW_IF_NOT_LOGGEDIN,
    component: ForgotPassword,
    hideInNavigation: true,
  },
  {
    path: '/profile',
    title: 'My Profile',
    showInHeader: true,
    routeType: ALLOW_IF_LOGGEDIN,
    component: Profile,
    hideInNavigation: true,
  },
  {
    path: '/change-password',
    title: 'Change Password',
    showInHeader: true,
    routeType: ALLOW_IF_LOGGEDIN,
    component: ChangePassword,
    hideInNavigation: true,
  },
  {
    path: '/sessions',
    title: 'My Sessions',
    showInHeader: true,
    routeType: ALLOW_IF_LOGGEDIN,
    component: Sessions,
    hideInNavigation: true,
    viewType: TABLE,
    accountsPermissions: [READ],
  },
  {
    path: '/logs',
    title: 'My Logs',
    showInHeader: true,
    routeType: ALLOW_IF_LOGGEDIN,
    component: Logs,
    hideInNavigation: true,
    viewType: TABLE,
    accountsPermissions: [READ],
  },
  // Accounts Management
  {
    path: '/accounts-management',
    title: 'Accounts Management',
    icon: faUsers,
    routeType: ALLOW_IF_LOGGEDIN,
    masterModuleName: ACCOUNTS_MANAGEMENT,
    isDummy: true,
    subRoutes: [
      {
        path: '/accounts-management/users',
        title: 'Users',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: USERS,
        permissionRequired: READ,
        component: UsersList,
        viewType: TABLE,
        masterModule: ACCOUNTS_MANAGEMENT,
        subRoutes: [
          {
            path: '/accounts-management/users/create',
            title: 'Create Users',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: USERS,
            permissionRequired: CREATE,
            component: UsersCreate,
            viewType: GRID,
            masterModule: ACCOUNTS_MANAGEMENT,
            hideInNavigation: true,
          },
          {
            path: '/accounts-management/users/update/:id',
            title: 'Update Users',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: USERS,
            permissionRequired: UPDATE,
            component: UsersUpdate,
            viewType: GRID,
            masterModule: ACCOUNTS_MANAGEMENT,
            hideInNavigation: true,
          },
          {
            path: '/accounts-management/users/wallet-transactions/:id',
            title: 'Wallet Transactions',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: USERS,
            permissionRequired: WALLET_TRANSACTIONS,
            component: UsersWalletTransactionsList,
            viewType: GRID,
            masterModule: ACCOUNTS_MANAGEMENT,
            hideInNavigation: true,
          },
          {
            path: '/accounts-management/users/fund-switching-transactions/:id',
            title: 'Fund Switching Transactions',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: USERS,
            permissionRequired: FUND_SWITCHING_TRANSACTIONS,
            component: UsersFundSwitchingTransactionsList,
            viewType: GRID,
            masterModule: ACCOUNTS_MANAGEMENT,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/accounts-management/users-kyc',
        title: 'Users KYC',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: USERS_KYC,
        permissionRequired: READ,
        component: UsersKYCList,
        viewType: TABLE,
        masterModule: ACCOUNTS_MANAGEMENT,
      },
      {
        path: '/accounts-management/users-bank-accounts',
        title: 'Users Bank Accounts',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: USERS_BANK_ACCOUNTS,
        permissionRequired: READ,
        component: UsersBankAccountsList,
        viewType: TABLE,
        masterModule: ACCOUNTS_MANAGEMENT,
      },
      {
        path: '/accounts-management/users-fund-requests',
        title: 'Users Fund Requests',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: USERS_FUND_REQUESTS,
        permissionRequired: READ,
        component: UsersFundRequestsList,
        viewType: TABLE,
        masterModule: ACCOUNTS_MANAGEMENT,
      },
      {
        path: '/accounts-management/users-withdraw-requests-gst',
        title: 'Users Withdraw Requests GST',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: USERS_WITHDRAW_REQUESTS,
        permissionRequired: READ,
        component: UsersWithdrawRequestsList,
        viewType: TABLE,
        masterModule: ACCOUNTS_MANAGEMENT,
      },
      {
        path: '/accounts-management/users-withdraw-requests-nongst',
        title: 'Users Withdraw Requests Non GST',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: USERS_WITHDRAW_REQUESTS,
        permissionRequired: READ,
        component: UsersWithdrawRequestsListNonGst,
        viewType: TABLE,
        masterModule: ACCOUNTS_MANAGEMENT,
      },
      {
        path: '/accounts-management/users-fund-transfers',
        title: 'Users Fund Transfers',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: USERS_FUND_TRANSFERS,
        permissionRequired: READ,
        component: UsersFundTransfersList,
        viewType: TABLE,
        masterModule: ACCOUNTS_MANAGEMENT,
      },
      {
        path: '/accounts-management/staff-accounts',
        title: 'Staff Accounts',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: STAFF_ACCOUNTS,
        permissionRequired: READ,
        component: StaffAccountsList,
        viewType: TABLE,
        masterModule: ACCOUNTS_MANAGEMENT,
        subRoutes: [
          {
            path: '/accounts-management/staff-accounts/create',
            title: 'Create Staff Account',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: STAFF_ACCOUNTS,
            permissionRequired: CREATE,
            component: StaffAccountsCreate,
            viewType: GRID,
            masterModule: ACCOUNTS_MANAGEMENT,
            hideInNavigation: true,
          },
          {
            path: '/accounts-management/staff-accounts/update/:id',
            title: 'Update Staff Account',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: STAFF_ACCOUNTS,
            permissionRequired: UPDATE,
            component: StaffAccountsUpdate,
            viewType: GRID,
            masterModule: ACCOUNTS_MANAGEMENT,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/accounts-management/roles-and-permissions',
        title: 'Roles & Permissions',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: ROLES_AND_PERMISSIONS,
        permissionRequired: READ,
        component: RolesAndPermissionsList,
        viewType: TABLE,
        masterModule: ACCOUNTS_MANAGEMENT,
        subRoutes: [
          {
            path: '/accounts-management/roles-and-permissions/create',
            title: 'Create Roles & Permissions',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: ROLES_AND_PERMISSIONS,
            permissionRequired: CREATE,
            component: RolesAndPermissionsCreate,
            viewType: GRID,
            masterModule: ACCOUNTS_MANAGEMENT,
            hideInNavigation: true,
          },
          {
            path: '/accounts-management/roles-and-permissions/update/:id',
            title: 'Update Roles & Permissions',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: ROLES_AND_PERMISSIONS,
            permissionRequired: UPDATE,
            component: RolesAndPermissionsUpdate,
            viewType: GRID,
            masterModule: ACCOUNTS_MANAGEMENT,
            hideInNavigation: true,
          },
        ],
      },
    ],
  },
  // Configurations
  {
    path: '/configurations',
    title: 'Configurations',
    icon: faGears,
    routeType: ALLOW_IF_LOGGEDIN,
    masterModuleName: CONFIGURATIONS,
    isDummy: true,
    subRoutes: [
      {
        path: '/configurations/firm-details',
        title: 'Firm Details',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: FIRM_DETAILS,
        permissionRequired: READ,
        component: FirmDetails,
        viewType: GRID,
        masterModule: CONFIGURATIONS,
      },
      {
        path: '/configurations/app-configuration',
        title: 'APP Configuration',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: APP_CONFIGURATION,
        permissionRequired: READ,
        component: AppConfiguration,
        viewType: GRID,
        masterModule: CONFIGURATIONS,
      },
      {
        path: '/configurations/bank-accounts',
        title: 'Bank Accounts',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: BANK_ACCOUNTS,
        permissionRequired: READ,
        component: BankAccountsList,
        viewType: TABLE,
        masterModule: CONFIGURATIONS,
        subRoutes: [
          {
            path: '/configurations/bank-accounts/create',
            title: 'Create Bank Account',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: BANK_ACCOUNTS,
            permissionRequired: CREATE,
            component: BankAccountsCreate,
            viewType: GRID,
            masterModule: CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/configurations/bank-accounts/update/:id',
            title: 'Update Bank Account',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: BANK_ACCOUNTS,
            permissionRequired: UPDATE,
            component: BankAccountsUpdate,
            viewType: GRID,
            masterModule: CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/configurations/scroll-message',
        title: 'Scroll Message',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: SCROLL_MESSAGE,
        permissionRequired: READ,
        component: ScrollMessage,
        viewType: GRID,
        masterModule: CONFIGURATIONS,
      },
      {
        path: '/configurations/sms-api-configuration',
        title: 'SMS API Configuration',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: SMS_API,
        permissionRequired: READ,
        component: SmsAPIConfiguration,
        viewType: GRID,
        masterModule: CONFIGURATIONS,
      },
      {
        path: '/configurations/whatsapp-api-configuration',
        title: 'Whatsapp API Configuration',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: WHATSAPP_API,
        permissionRequired: READ,
        component: WhatsappAPIConfiguration,
        viewType: GRID,
        masterModule: CONFIGURATIONS,
      },
      {
        path: '/configurations/payment-gateway-configuration',
        title: 'Payment Gateway Configuration',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: PAYMENT_GATEWAY_CONFIGURATION,
        permissionRequired: READ,
        component: PaymentGatewayConfigurationTable,
        viewType: TABLE,
        masterModule: CONFIGURATIONS,
        hideForVerions: ['V1'],
        subRoutes: [
          {
            path: '/configurations/payment-gateway-configuration/create',
            title: 'Create Payment Gateway Configuration',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: PAYMENT_GATEWAY_CONFIGURATION,
            permissionRequired: CREATE,
            component: PaymentGatewayConfigurationCreate,
            viewType: GRID,
            masterModule: CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/configurations/payment-gateway-configuration/update/:id',
            title: 'Update Payment Gateway Configuration',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: PAYMENT_GATEWAY_CONFIGURATION,
            permissionRequired: UPDATE,
            component: PaymentGatewayConfigurationUpdate,
            viewType: GRID,
            masterModule: CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/configurations/send-notifications',
        title: 'Send Notifications',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: SEND_NOTIFICATIONS,
        permissionRequired: CREATE,
        component: SendNotifications,
        viewType: GRID,
        masterModule: CONFIGURATIONS,
      },
    ],
  },
  // Recharge Configurations
  {
    path: '/recharge-configurations',
    title: 'Recharge Configurations',
    icon: faGears,
    routeType: ALLOW_IF_LOGGEDIN,
    masterModuleName: RECHARGE_CONFIGURATIONS,
    isDummy: true,
    subRoutes: [
      {
        path: '/recharge-configurations/circles',
        title: 'Circles',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: CIRCLES,
        permissionRequired: READ,
        component: CirclesList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
        subRoutes: [
          {
            path: '/recharge-configurations/circles/create',
            title: 'Create Circle',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: CIRCLES,
            permissionRequired: CREATE,
            component: CirclesCreate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/recharge-configurations/circles/update/:id',
            title: 'Update Circle',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: CIRCLES,
            permissionRequired: UPDATE,
            component: CirclesUpdate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/recharge-configurations/operators',
        title: 'Operators',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: OPERATORS,
        permissionRequired: READ,
        component: OperatorsList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
        subRoutes: [
          {
            path: '/recharge-configurations/operators/create',
            title: 'Create Operator',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: OPERATORS,
            permissionRequired: CREATE,
            component: OperatorsCreate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/recharge-configurations/operators/update/:id',
            title: 'Update Operator',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: OPERATORS,
            permissionRequired: UPDATE,
            component: OperatorsUpdate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/recharge-configurations/categories',
        title: 'Categories',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: CATEGORIES,
        permissionRequired: READ,
        component: CategoriesList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
        hideForVerions: ['V2'],
        subRoutes: [
          {
            path: '/recharge-configurations/categories/create',
            title: 'Create Category',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: CATEGORIES,
            permissionRequired: CREATE,
            component: CategoriesCreate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/recharge-configurations/categories/update/:id',
            title: 'Update Category',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: CATEGORIES,
            permissionRequired: UPDATE,
            component: CategoriesUpdate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/recharge-configurations/admin-operator-margins',
        title: 'Admin Operator Margins',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: ADMIN_OPERATOR_MARGINS,
        permissionRequired: READ,
        component: AdminOperatorMarginList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
        subRoutes: [
          {
            path: '/recharge-configurations/admin-operator-margins/create',
            title: 'Create Admin Operator Margin',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: ADMIN_OPERATOR_MARGINS,
            permissionRequired: CREATE,
            component: AdminOperatorMarginCreate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/recharge-configurations/admin-operator-margins/update/:id',
            title: 'Update Admin Operator Margin',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: ADMIN_OPERATOR_MARGINS,
            permissionRequired: UPDATE,
            component: AdminOperatorMarginUpdate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/recharge-configurations/admin-user-operator-margins',
        title: 'Admin User Operator Margins',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: ADMIN_USER_OPERATOR_MARGINS,
        permissionRequired: READ,
        component: AdminUserOperatorMarginList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
        subRoutes: [
          {
            path: '/recharge-configurations/admin-user-operator-margins/create',
            title: 'Create Admin User Operator Margin',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: ADMIN_USER_OPERATOR_MARGINS,
            permissionRequired: CREATE,
            component: AdminUserOperatorMarginCreate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/recharge-configurations/admin-user-operator-margins/update/:id',
            title: 'Update Admin User Operator Margin',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: ADMIN_USER_OPERATOR_MARGINS,
            permissionRequired: UPDATE,
            component: AdminUserOperatorMarginUpdate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/configurations/plan-api-configuration',
        title: 'Plan API Configuration',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: PLAN_API_CONFIGURATION,
        permissionRequired: READ,
        component: PlanAPIConfiguration,
        viewType: GRID,
        masterModule: RECHARGE_CONFIGURATIONS,
      },
      {
        path: '/recharge-configurations/api-groups',
        title: 'API Groups',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: API_PROVIDERS,
        permissionRequired: READ,
        component: APIProvidersList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
        subRoutes: [
          {
            path: '/recharge-configurations/api-groups/create',
            title: 'Create API Group',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: API_PROVIDERS,
            permissionRequired: CREATE,
            component: APIProvidersCreate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/recharge-configurations/api-groups/update/:id',
            title: 'Update API Group',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: API_PROVIDERS,
            permissionRequired: UPDATE,
            component: APIProvidersUpdate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/recharge-configurations/seller-apis',
        title: 'Seller APIS',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: SELLER_APIS,
        permissionRequired: READ,
        component: SellerAPISList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
        subRoutes: [
          {
            path: '/recharge-configurations/seller-apis/create',
            title: 'Create Seller API',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: SELLER_APIS,
            permissionRequired: CREATE,
            component: SellerAPISCreate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/recharge-configurations/seller-apis/update/:id',
            title: 'Update Seller API',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: SELLER_APIS,
            permissionRequired: UPDATE,
            component: SellerAPISUpdate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/recharge-configurations/operators-blocker',
        title: 'Operators Blockers',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: OPERATORS_BLOCKER,
        permissionRequired: READ,
        component: OperatorBlockerList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
        subRoutes: [
          {
            path: '/recharge-configurations/operators-blocker/create',
            title: 'Create Operators Blocker',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: OPERATORS_BLOCKER,
            permissionRequired: CREATE,
            component: OperatorBlockerCreate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/recharge-configurations/buyer-margins',
        title: 'Buyer Margins',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: BUYER_MARGINS,
        permissionRequired: READ,
        component: BuyerMarginsList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
      },
      {
        path: '/recharge-configurations/seller-margins',
        title: 'Seller Margins',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: SELLER_MARGINS,
        permissionRequired: READ,
        component: SellerMarginsList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
      },
      {
        path: '/recharge-configurations/auto-resolve-complaints',
        title: 'Auto Resolve Complaints',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: AUTO_RESOLVE_COMPLAINTS,
        permissionRequired: READ,
        component: AutoResolveComplaintsList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
        subRoutes: [
          {
            path: '/recharge-configurations/auto-resolve-complaints/create',
            title: 'Create Auto Resolve Complaint',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: AUTO_RESOLVE_COMPLAINTS,
            permissionRequired: CREATE,
            component: AutoResolveComplaintsCreate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/recharge-configurations/auto-resolve-complaints/update/:id',
            title: 'Update Auto Resolve Complaint',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: AUTO_RESOLVE_COMPLAINTS,
            permissionRequired: UPDATE,
            component: AutoResolveComplaintsUpdate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
      {
        path: '/recharge-configurations/lapu-slugs',
        title: 'LAPU Slugs',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: LAPU_SLUGS,
        permissionRequired: READ,
        component: LapuSlugsList,
        viewType: TABLE,
        masterModule: RECHARGE_CONFIGURATIONS,
        subRoutes: [
          {
            path: '/recharge-configurations/lapu-slugs/create',
            title: 'Create LAPU Slug',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: LAPU_SLUGS,
            permissionRequired: CREATE,
            component: LapuSlugsCreate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
          {
            path: '/recharge-configurations/lapu-slugs/update/:id',
            title: 'Update LAPU Slug',
            routeType: ALLOW_IF_LOGGEDIN,
            moduleName: LAPU_SLUGS,
            permissionRequired: UPDATE,
            component: LapuSlugsUpdate,
            viewType: GRID,
            masterModule: RECHARGE_CONFIGURATIONS,
            hideInNavigation: true,
          },
        ],
      },
    ],
  },
  // Transactions
  {
    path: '/transactions',
    title: 'Transactions',
    icon: faIndianRupeeSign,
    routeType: ALLOW_IF_LOGGEDIN,
    masterModuleName: TRANSACTIONS,
    isDummy: true,
    subRoutes: [
      {
        path: '/transactions/buyer-recharge-transactions',
        title: 'Buyer Recharge Transactions',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: BUYER_RECHARGE_TRANSACTIONS,
        permissionRequired: READ,
        component: BuyerRechargeTransactionsList,
        viewType: TABLE,
        masterModule: TRANSACTIONS,
      },
      {
        path: '/transactions/seller-recharge-transactions',
        title: 'Seller Recharge Transactions',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: SELLER_RECHARGE_TRANSACTIONS,
        permissionRequired: READ,
        component: SellerRechargeTransactionsList,
        viewType: TABLE,
        masterModule: TRANSACTIONS,
      },
      {
        path: '/transactions/pending-recharge-transactions',
        title: 'Pending Recharge Transactions',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: PENDING_RECHARGE_TRANSACTIONS,
        permissionRequired: READ,
        component: PendingRechargeTransactionsList,
        viewType: TABLE,
        masterModule: TRANSACTIONS,
      },
      {
        path: '/transactions/disputed-recharge-transactions',
        title: 'Disputed Recharge Transactions',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: DISPUTED_RECHARGE_TRANSACTIONS,
        permissionRequired: READ,
        component: DisputedRechargeTransactionsList,
        viewType: TABLE,
        masterModule: TRANSACTIONS,
      },
      {
        path: '/transactions/live-recharge-transactions',
        title: 'Live Recharge Transactions',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: LIVE_RECHARGE_TRANSACTIONS,
        permissionRequired: READ,
        component: LiveRechargeTransactionsList,
        viewType: TABLE,
        masterModule: TRANSACTIONS,
        target: '_blank',
      },
      {
        path: "/transactions/issue-transactions",
        title: "Issue Transactions",
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: ISSUE_RECHARGE_TRANSACTIONS,
        permissionRequired: READ,
        component: IssueRechargeTransactionsList,
        viewType: TABLE,
        masterModule: TRANSACTIONS,
      },
    ],
  },
  // Reports
  {
    path: '/reports',
    title: 'Reports',
    icon: faChartPie,
    routeType: ALLOW_IF_LOGGEDIN,
    masterModuleName: REPORTS,
    isDummy: true,
    subRoutes: [
      {
        path: '/reports/buyers-operator-day-book',
        title: 'Buyers Operator Day Book',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: BUYERS_OPERATORS_DAY_BOOK,
        permissionRequired: READ,
        component: BuyersOperatorDayBook,
        viewType: TABLE,
        masterModule: REPORTS,
      },
      {
        path: '/reports/sellers-operator-day-book',
        title: 'Sellers Operator Day Book',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: SELLERS_OPERATORS_DAY_BOOK,
        permissionRequired: READ,
        component: SellersOperatorDayBook,
        viewType: TABLE,
        masterModule: REPORTS,
      },
      {
        path: '/reports/daybook',
        title: 'Daybook',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: DAY_BOOK,
        permissionRequired: READ,
        component: Daybook,
        viewType: TABLE,
        masterModule: REPORTS,
      },
      {
        path: '/reports/downloads',
        title: 'Downloads',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: DOWNLOADS,
        permissionRequired: READ,
        component: Downloads,
        viewType: GRID,
        masterModule: REPORTS,
      },
    ],
  }, // Invoicing
  {
    path: '/invoicing',
    title: 'Invoicing',
    icon: faFileInvoice,
    routeType: ALLOW_IF_LOGGEDIN,
    masterModuleName: INVOICING,
    isDummy: true,
    subRoutes: [
      {
        path: '/invoicing/buyer-invoices',
        title: 'Buyer Invoices',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: BUYER_INVOICES,
        permissionRequired: READ,
        component: BuyerInvoices,
        viewType: TABLE,
        masterModule: INVOICING,
      },
      {
        path: '/invoicing/seller-invoices',
        title: 'Seller Invoices',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: SELLER_INVOICES,
        permissionRequired: READ,
        component: SellerInvoices,
        viewType: TABLE,
        masterModule: INVOICING,
      },
      {
        path: '/invoicing/payment-gateway-deposits',
        title: 'Payment Gateway Deposits',
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: PAYMENT_GATEWAY_DEPOSITS,
        permissionRequired: READ,
        component: PaymentGatewayDepositsTable,
        viewType: TABLE,
        masterModule: INVOICING,
        hideForVerions: ['V1'],
      },
    ],
  },
  // Support
  {
    path: "/support",
    title: "Support",
    icon: faHeadphones,
    routeType: ALLOW_IF_LOGGEDIN,
    masterModuleName: SUPPORT,
    isDummy: true,
    subRoutes: [
      {
        path: "/support/support-tickets",
        title: "Support Tickets",
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: SUPPORT_TICKETS,
        permissionRequired: READ,
        component: SupportTickets,
        viewType: TABLE,
        masterModule: SUPPORT,
      },
      {
        path: "/support/seller-apis-support-tickets",
        title: "Seller APIS Support Tickets",
        routeType: ALLOW_IF_LOGGEDIN,
        moduleName: SELLER_APIS_SUPPORT_TICKETS,
        permissionRequired: READ,
        component: SellerAPISSupportTickets,
        viewType: TABLE,
        masterModule: SUPPORT,
      },
    ],
  },
];

export { ROUTES };
